"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.formatNumberToFixed = exports.humanizeFileSize = exports.getPercentageTrend = exports.formatToOnlyThousands = exports.formatNumber = exports.formatCurrencyWithNegativeParentheses = exports.roundToMultiple = exports.roundToTenths = exports.formatToIntegerWithCurrency = exports.formatToThousandsWithCurrency = exports.formatToThousands = exports.formatToMillions = exports.formatCurrency = exports.isEven = exports.isNumber = exports.getCurrencySettingsByCode = exports.Country = exports.CountryList = exports.CountryCurrency = void 0;
var numeral_1 = __importDefault(require("numeral"));
var lodash_1 = require("lodash");
var CountryCurrency;
(function (CountryCurrency) {
    CountryCurrency["GREAT_BRITAIN"] = "GBP";
    CountryCurrency["SOUTH_AFRICA"] = "ZAR";
})(CountryCurrency = exports.CountryCurrency || (exports.CountryCurrency = {}));
exports.CountryList = Object.freeze({
    GREAT_BRITAIN: "GB",
    SOUTH_AFRICA: "ZA"
});
exports.Country = Object.freeze({
    GB: {
        date: {
            format: "dd-MM-yyyy"
        },
        currency: {
            symbol: "£",
            thousandSeparator: ",",
            code: CountryCurrency.GREAT_BRITAIN
        },
        locale: "en-gb"
    },
    ZA: {
        date: {
            format: "yyyy-MM-dd"
        },
        currency: {
            symbol: "R",
            thousandSeparator: " ",
            code: CountryCurrency.SOUTH_AFRICA
        },
        locale: "en-za"
    }
});
var getCurrencySettingsByCode = function (currencyCode) {
    var _a, _b;
    if (currencyCode === void 0) { currencyCode = CountryCurrency.GREAT_BRITAIN; }
    var byCurrencyCode = Object.values(exports.Country)
        .map(function (countryDetails) { return countryDetails.currency; })
        .find(function (currencyDetails) { return currencyDetails.code === currencyCode; });
    if (!byCurrencyCode) {
        return (_b = (_a = Object.entries(exports.Country).find(function (_a) {
            var countryKey = _a[0];
            return countryKey === currencyCode;
        })) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.currency;
    }
    return byCurrencyCode;
};
exports.getCurrencySettingsByCode = getCurrencySettingsByCode;
var isNumber = function (variable) {
    if (variable === null || (0, lodash_1.isObject)(variable)) {
        return false;
    }
    return !Number.isNaN(Number(variable));
};
exports.isNumber = isNumber;
var isEven = function (number) { return number % 2 === 0; };
exports.isEven = isEven;
// TODO: for instance only get the value, the currency code
// will be implemented in a near future
var normalizeAmountObject = function (amount) {
    return (0, lodash_1.isObject)(amount)
        ? __assign(__assign({}, amount), { value: parseFloat(String(amount.value)) }) : {
        value: parseFloat(String(amount)),
        code: CountryCurrency.GREAT_BRITAIN
    };
};
function formatCurrency(number, formatStr) {
    if (formatStr === void 0) { formatStr = "0,0[.]00"; }
    var amountObject = normalizeAmountObject(number);
    if (!amountObject.code) {
        return (0, numeral_1["default"])(amountObject.value).format("\u00A3".concat(formatStr));
    }
    else {
        var _a = (0, exports.getCurrencySettingsByCode)(amountObject.code), symbol = _a.symbol, thousandSeparator = _a.thousandSeparator;
        var formattedValue = (0, numeral_1["default"])(amountObject.value)
            .format(formatStr)
            .replace(/,|\s/, thousandSeparator);
        return "".concat(symbol).concat(formattedValue);
    }
}
exports.formatCurrency = formatCurrency;
function formatToMillions(number) {
    return (0, numeral_1["default"])(number).format("0.0a");
}
exports.formatToMillions = formatToMillions;
function formatToThousands(number) {
    return (0, numeral_1["default"])(number).format("0a");
}
exports.formatToThousands = formatToThousands;
function formatToThousandsWithCurrency(number) {
    return formatCurrency(number, "0a");
}
exports.formatToThousandsWithCurrency = formatToThousandsWithCurrency;
function formatToIntegerWithCurrency(number) {
    return formatCurrency(number, "0,0");
}
exports.formatToIntegerWithCurrency = formatToIntegerWithCurrency;
function roundToTenths(number) {
    return "".concat((0, numeral_1["default"])(number).format("0.0"), "x");
}
exports.roundToTenths = roundToTenths;
function roundToMultiple(number, multiple) {
    return Math.round(Number(number) / multiple) * multiple;
}
exports.roundToMultiple = roundToMultiple;
function formatCurrencyWithNegativeParentheses(number, formatStr) {
    if (number < 0) {
        return formatCurrency(number, "($0,0)");
    }
    return formatCurrency(number, formatStr);
}
exports.formatCurrencyWithNegativeParentheses = formatCurrencyWithNegativeParentheses;
function formatNumber(number, formatStr) {
    if (formatStr === void 0) { formatStr = "($0,0)"; }
    return (0, numeral_1["default"])(number).format(formatStr);
}
exports.formatNumber = formatNumber;
// Fix all numbers to use only the K modifier
// This is the standard on the new UI
function formatToOnlyThousands(number) {
    var cappedNumber = Math.round(Number(number) / 1000);
    if (cappedNumber === 0)
        return "0k";
    if (cappedNumber < 0)
        return "(".concat(formatCurrency(Math.abs(cappedNumber), "0,0"), "k)");
    return "".concat(formatCurrency(cappedNumber, "0,0"), "k");
}
exports.formatToOnlyThousands = formatToOnlyThousands;
var getPercentageTrend = function (initialValue, finalValue, percentageFactor) {
    if (percentageFactor === void 0) { percentageFactor = 100; }
    return Math.round(((finalValue - initialValue) / Math.abs(initialValue)) * percentageFactor);
};
exports.getPercentageTrend = getPercentageTrend;
var humanizeFileSize = function (bytes, decimalDigits) {
    if (decimalDigits === void 0) { decimalDigits = 0; }
    var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0)
        return "0 Byte";
    var i = Math.floor(Math.log(bytes) / Math.log(1024));
    return "".concat((bytes / Math.pow(1024, i)).toFixed(decimalDigits), " ").concat(sizes[i]);
};
exports.humanizeFileSize = humanizeFileSize;
var formatNumberToFixed = function (value) {
    return value ? Math.abs(value).toFixed(0) : "-";
};
exports.formatNumberToFixed = formatNumberToFixed;
